import { Throw } from 'components/Throw'
import { Route as Router5Route } from 'router'
import { AdminWorkersView, ProvingsIndexView } from 'views'
import { DangerousGoodsView } from 'views/AdminDangerousGoods'
import { AdminDepartmentView } from 'views/AdminDepartmentView'
import { AdminDsgvoView } from 'views/AdminDsgvoView'
import { AdminFileTemplatesView } from 'views/AdminFileTemplatesView'
import { AdminGeneralSettingsView } from 'views/AdminGeneralSettingsView/AdminGeneralSettingsView'
import { AdminKeywordsView } from 'views/AdminKeywordsView'
import { AdminMailTemplatesView } from 'views/AdminMailTemplatesView'
import { AdminMaintenanceView } from 'views/AdminMaintenanceView'
import { AdminMaterialsView } from 'views/AdminMaterialsView'
import { AdminNewsView } from 'views/AdminNewsView'
import { AdminOrderIdsView } from 'views/AdminOrderIdsView'
import { AdminProvingGroundsView } from 'views/AdminProvingGroundsView'
import { AdminResourcesView } from 'views/AdminResourcesView'
import { AdminSenderRecipientView } from 'views/AdminSenderRecipientView'
import { AdminWikiView } from 'views/AdminWikiView'
import {
  ArchiveCreatorView,
  ArchiveDeclinedCanceledView,
  ArchiveNrView,
  ArchiveParticipantsByAccomodationView,
  ArchiveParticipantsByNameView,
  ArchiveParticipantsByProvingView,
  ArchiveProvingGroundView,
} from 'views/ArchiveViews'
import { ArchiveParticipantsByDepartmentView } from 'views/ArchiveViews/ArchiveParticipantsByDepartmentView'
import { ArchiveParticipantsByEndDateView } from 'views/ArchiveViews/ArchiveParticipantsByEndDateView'
import { ArchiveParticipantsByStartDateView } from 'views/ArchiveViews/ArchiveParticipantsByStartDateView'
import { ArchiveParticipantsByStreckenHotelView } from 'views/ArchiveViews/ArchiveParticipantsByStreckenHotelView'
import { AssignedWorkerView } from 'views/AssignedWorkerView'
import {
  BookingsAppletView,
  BookingsManagerArchiveView,
  BookingsManagerDateView,
} from 'views/BookingsView'
import { CostDistributionView } from 'views/CostDistributionView'
import { EditorView } from 'views/EditorView'
import { HomeIndexView } from 'views/HomeIndexView'
import { HomeScreen } from 'views/HomeScreenView/HomeScreen'
import { MailboxViewAuthorized } from 'views/MailboxView'
import { MyBookingsView } from 'views/MyBookingsView'
import { MyProvingsIndexView } from 'views/MyProvingIndexView'
import { NewsView } from 'views/NewsView/NewsView'
import { ParticipantsByEndDateView } from 'views/Participants/ParticipantsByEndDate'
import { ParticipantsByStartDateView } from 'views/Participants/ParticipantsByStartDate/ParticipantsByStartDateView'
import { DayOfArrivalView } from 'views/ParticipantViews'
import { BookingByDepartmentView } from 'views/ParticipantViews/BookingByDepartment'
import { BookingByParticipantView } from 'views/ParticipantViews/BookingByParticipant/BookingByParticipantView'
import { BookingByStatusView } from 'views/ParticipantViews/BookingByStatusView'
import { BookingByUnknownParticipantView } from 'views/ParticipantViews/BookingByUnknownParticipant'
import { ParticipantByHotelView } from 'views/ParticipantViews/HotelView'
import { ParticipantByTrackHotelView } from 'views/ParticipantViews/TrackhotelView/ParticipantByTrackHotelView'
import { PersonsByDepartmentView } from 'views/Persons/PersonsByDepartment'
import { PersonsByNameView } from 'views/Persons/PersonsByNameView'
import { PersonsByTypeView } from 'views/Persons/PersonsByType'
import { ProvingCreatorView } from 'views/ProvingCreatorView'
import { ProvingDateView } from 'views/ProvingDateView'
import { ProvingDepartmentView } from 'views/ProvingDepartmentView'
import { ProvingDetailsView } from 'views/ProvingDetailsView'
import { ProvingNmfView } from 'views/ProvingNmfView'
import { ProvingNrView } from 'views/ProvingNrView'
import { ProvingsByMaintenanceHeadView } from 'views/ProvingsByMaintenanceHeadView'
import { ProvingStatusView } from 'views/ProvingStatusView'
import {
  ResourceOfficeDateBookingsView,
  ResourceOfficeLocationBookingsView,
  ResourceVehicleModellBookingsView,
  ResourceVehicleNumberBookingsView,
} from 'views/ResourceBookingsView'
import { ResourceManagerView } from 'views/ResourceManagerView'
import { SynergyView } from 'views/SynergyView/SynergyView'
import { TaxRequirementsView } from 'views/TaxRequirementsView'
import { WikiView } from 'views/WikiView'

export type Route = Omit<Router5Route, 'children'> & {
  component?: any
  iconName?: string
  children?: Route[]
}

export const Home: Route = {
  name: 'home',
  path: '/',
  component: HomeScreen,
}
export const Todos: Route = {
  name: 'todos',
  path: '/todos',
  component: HomeIndexView,
}
export const Mailbox: Route = {
  name: 'mailbox',
  path: '/mailbox',
  component: MailboxViewAuthorized,
}
export const Wiki: Route = {
  name: 'wiki',
  path: '/wiki',
  component: WikiView,
}
export const News: Route = {
  name: 'news',
  path: '/news',
  component: NewsView,
}
export const Synergies: Route = {
  name: 'synergies',
  path: '/synergies',
  component: SynergyView,
}

/** PROVINGS */
export const ProvingsIndex: Route = {
  name: 'index',
  path: '/',
  component: ProvingsIndexView,
}
export const ProvingDetails: Route = {
  name: 'details',
  path: '/:id?:page',
  component: ProvingDetailsView,
}
export const ResourceManagers: Route = {
  name: 'provingsResourceManager',
  path: '/provingsResourceManager',
  component: ResourceManagerView,
}
export const Editors: Route = {
  name: 'provingsEditor',
  path: '/provingsEditor',
  component: EditorView,
}
export const ProvingsStatus: Route = {
  name: 'provingsStatus',
  path: '/provingsStatus',
  component: ProvingStatusView,
}
export const ProvingsNr: Route = {
  name: 'provingsNr',
  path: '/provingsNr',
  component: ProvingNrView,
}
export const ProvingsDate: Route = {
  name: 'provingsDate',
  path: '/provingsDate',
  component: ProvingDateView,
}
export const ProvingsDepartment: Route = {
  name: 'provingsDepartment',
  path: '/provingsDepartment',
  component: ProvingDepartmentView,
}
export const ProvingsCreator: Route = {
  name: 'provingsCreator',
  path: '/provingsCreator',
  component: ProvingCreatorView,
}
export const ProvingsNmf: Route = {
  name: 'provingsNmf',
  path: '/provingsNmf',
  component: ProvingNmfView,
}
export const Provings: Route = {
  name: 'provings',
  path: '/provings',
  forwardTo: 'provings.index',
  children: [
    ProvingDetails,
    ResourceManagers,
    Editors,
    ProvingsStatus,
    ProvingsNr,
    ProvingsDate,
    ProvingsDepartment,
    ProvingsCreator,
    ProvingsNmf,
  ],
}

/** ASSIGNED WORKER */
export const AssignedWorker: Route = {
  name: 'assignedWorker',
  path: '/assignedWorker',
  component: AssignedWorkerView,
}

/** PROVINGS BY MAINTENANCEHEAD */
export const ProvingsByMaintenanceHead: Route = {
  name: 'byMaintenanceHead',
  path: '/byMaintenanceHead',
  component: ProvingsByMaintenanceHeadView,
}

/** MY BOOKINGS */
export const MyBookings: Route = {
  name: 'myBookings',
  path: '/myBookings',
  component: MyBookingsView,
}

/** PARTICIPANTS */
export const ParticipantByProving: Route = {
  name: 'participantByProving',
  path: '/participantByProving',
  component: DayOfArrivalView,
}

export const ParticipantByHotel: Route = {
  name: 'participantByHotel',
  path: '/participantByHotel',
  component: ParticipantByHotelView,
}

export const ParticipantByStartDate: Route = {
  name: 'participantByStartDate',
  path: '/participantByStartDate',
  component: ParticipantsByStartDateView,
}

export const ParticipantByEndDate: Route = {
  name: 'participantByEndDate',
  path: '/participantByEndDate',
  component: ParticipantsByEndDateView,
}

export const ParticipantByTrackhotel: Route = {
  name: 'participantByTrackhotel',
  path: '/participantByTrackhotel',
  component: ParticipantByTrackHotelView,
}

export const BookingByStatus: Route = {
  name: 'bookingByStatus',
  path: '/bookingByStatus',
  component: BookingByStatusView,
}

export const BookingByParticipant: Route = {
  name: 'bookingByParticipant',
  path: '/bookingByParticipant',
  component: BookingByParticipantView,
}

export const BookingByDepartment: Route = {
  name: 'bookingByDepartment',
  path: '/bookingByDepartment',
  component: BookingByDepartmentView,
}

export const BookingByUnknownParticipant: Route = {
  name: 'bookingByUnknownParticipant',
  path: '/bookingByUnknownParticipant',
  component: BookingByUnknownParticipantView,
}

export const BookingAdministration: Route = {
  name: 'bookingAdministration',
  path: '/bookingAdministration',
  children: [
    BookingByStatus,
    BookingByParticipant,
    BookingByDepartment,
    BookingByUnknownParticipant,
  ],
}

export const Participants: Route = {
  name: 'participants',
  path: '/participants',
  forwardTo: 'participants.index',
  children: [
    ParticipantByProving,
    ParticipantByHotel,
    ParticipantByStartDate,
    ParticipantByEndDate,
    ParticipantByTrackhotel,
    BookingAdministration,
  ],
}

/** PERSONS */
export const PersonsByDepartment: Route = {
  name: 'personsByDepartment',
  path: '/personsByDepartment',
  component: PersonsByDepartmentView,
}
export const PersonsByName: Route = {
  name: 'personsByName',
  path: '/personsByName',
  component: PersonsByNameView,
}
export const PersonsByType: Route = {
  name: 'personsByType',
  path: '/personsByType',
  component: PersonsByTypeView,
}

export const Persons: Route = {
  name: 'persons',
  path: '/persons',
  forwardTo: 'persons.index',
  children: [PersonsByName, PersonsByType, PersonsByDepartment],
}

/** ARCHIVE */
export const ArchiveProvingGround: Route = {
  name: 'archiveProvingGround',
  path: '/archiveProvingGround',
  component: ArchiveProvingGroundView,
}
export const ArchiveNr: Route = {
  name: 'archiveNr',
  path: '/archiveNr',
  component: ArchiveNrView,
}
export const ArchiveCreator: Route = {
  name: 'archiveCreator',
  path: '/archiveCreator',
  component: ArchiveCreatorView,
}
export const ArchiveDeclinedCanceled: Route = {
  name: 'archiveDeclinedCanceled',
  path: '/archiveDeclinedCanceled',
  component: ArchiveDeclinedCanceledView,
}
export const ArchiveParticipantsByName: Route = {
  name: 'archiveParticipantsByName',
  path: '/name',
  component: ArchiveParticipantsByNameView,
}
export const ArchiveParticipantsByAccomodation: Route = {
  name: 'ArchiveParticipantsByAccomodation',
  path: '/accomodation',
  component: ArchiveParticipantsByAccomodationView,
}
export const ArchiveParticipantsByProving: Route = {
  name: 'ArchiveParticipantsByProving',
  path: '/proving',
  component: ArchiveParticipantsByProvingView,
}
export const ArchiveParticipantsByStreckenHotel: Route = {
  name: 'ArchiveParticipantsByStreckenHotel',
  path: '/streckenhotel',
  component: ArchiveParticipantsByStreckenHotelView,
}
export const ArchiveParticipantsByStartDate: Route = {
  name: 'ArchiveParticipantsByStartDate',
  path: '/startDate',
  component: ArchiveParticipantsByStartDateView,
}
export const ArchiveParticipantsByEndDate: Route = {
  name: 'ArchiveParticipantsByEndDate',
  path: '/endDate',
  component: ArchiveParticipantsByEndDateView,
}
export const ArchiveParticipantsByDepartment: Route = {
  name: 'ArchiveParticipantsByDepartment',
  path: '/department',
  component: ArchiveParticipantsByDepartmentView,
}

export const ArchivesProvings: Route = {
  name: 'archivesProvings',
  path: '/provings',
  children: [
    ArchiveProvingGround,
    ArchiveNr,
    ArchiveCreator,
    ArchiveDeclinedCanceled,
  ],
}
export const ArchivesParticipants: Route = {
  name: 'ArchivesParticipants',
  path: '/participants',
  children: [
    ArchiveParticipantsByName,
    ArchiveParticipantsByAccomodation,
    ArchiveParticipantsByProving,
    ArchiveParticipantsByDepartment,
    ArchiveParticipantsByStartDate,
    ArchiveParticipantsByEndDate,
  ],
}
export const Archives: Route = {
  name: 'archives',
  path: '/archives',
  forwardTo: 'archives.index',
  children: [ArchivesProvings, ArchivesParticipants],
}

export const MyProvings: Route = {
  name: 'myprovings',
  path: '/myprovings',
  component: MyProvingsIndexView,
}

export const BookingManager: Route = {
  name: 'bookingManager',
  path: '/bookingManager',
  forwardTo: '/bookingsAppletView',
  children: [
    {
      name: 'bookingsAppletView',
      path: '/bookingsAppletView',
      component: BookingsAppletView,
    },
    {
      name: 'bookingsManagerDateView',
      path: '/bookingsManagerDateView',
      component: BookingsManagerDateView,
    },
    {
      name: 'bookingsManagerArchiveView',
      path: '/bookingsManagerArchiveView',
      component: BookingsManagerArchiveView,
    },
  ],
}

export const ResourceBookings: Route = {
  name: 'resourceBookings',
  path: '/resourceBookings',
  forwardTo: '/resourceBookingsol',
  children: [
    {
      name: 'resourceBookingsol',
      path: '/resourceBookingsol',
      component: ResourceOfficeLocationBookingsView,
    },
    {
      name: 'resourceBookingsod',
      path: '/resourceBookingsod',
      component: ResourceOfficeDateBookingsView,
    },
    {
      name: 'resourceBookingsvm',
      path: '/resourceBookingsvm',
      component: ResourceVehicleModellBookingsView,
    },
    {
      name: 'resourceBookingsvn',
      path: '/resourceBookingsvn',
      component: ResourceVehicleNumberBookingsView,
    },
  ],
}

/** ADMIN SETTINGS */
export const AdminSettings: Route = {
  name: 'settings',
  path: '/settings',
  children: [
    {
      name: 'fileTemplates',
      path: '/fileTemplates',
      component: AdminFileTemplatesView,
    },
    {
      name: 'keyWordList',
      path: '/keyWordList',
      component: AdminKeywordsView,
    },
    {
      name: 'generalSettings',
      path: '/generalSettings',
      component: AdminGeneralSettingsView,
    },
  ],
}

/** ADMIN DATA */
export const AdminData: Route = {
  name: 'data',
  path: '/data',
  forwardTo: 'admin.data.provingGrounds',
  children: [
    {
      name: 'provingGrounds',
      path: '/proving-grounds',
      component: AdminProvingGroundsView,
    },
    {
      name: 'resources',
      path: '/resources?:search&:category&:type',
      component: AdminResourcesView,
    },
    {
      name: 'workers',
      path: '/workers?:search&:key',
      component: AdminWorkersView,
    },
    {
      name: 'orderIds',
      path: '/order-ids?:search',
      component: AdminOrderIdsView,
    },
    {
      name: 'materials',
      path: '/materials',
      component: AdminMaterialsView,
    },
    {
      name: 'dangerousGoods',
      path: '/dangerousGoods?:search',
      component: DangerousGoodsView,
    },
    {
      name: 'senderRecipients',
      path: '/senderRecipients',
      component: AdminSenderRecipientView,
    },
    {
      name: 'mailTemplates',
      path: '/mailTemplates',
      component: AdminMailTemplatesView,
    },
    {
      name: 'news',
      path: '/news',
      component: AdminNewsView,
    },
    {
      name: 'wiki',
      path: '/wiki',
      component: AdminWikiView,
    },
    {
      name: 'maintenanceArea',
      path: '/maintenanceArea',
      component: AdminMaintenanceView,
    },
    {
      name: 'department',
      path: '/department',
      component: AdminDepartmentView,
    },
  ],
}

/** Admin Tax Requirements */
export const TaxRequirements: Route = {
  name: 'taxRequirements',
  path: '/taxRequirements',
  component: TaxRequirementsView,
}

export const CostDistribution: Route = {
  name: 'costDistribution',
  path: '/costDistribution',
  component: CostDistributionView,
}

export const Dsgvo: Route = {
  name: 'dsgvo',
  path: '/dsgvo',
  component: AdminDsgvoView,
}

export const Admin: Route = {
  name: 'admin',
  path: '/_admin',
  forwardTo: 'admin.data.provingGrounds',
  children: [
    Home,
    AdminData,
    AdminSettings,
    TaxRequirements,
    CostDistribution,
    Dsgvo,
  ],
}

/** MISC */
export const ThrowRoute: Route = {
  name: 'throw',
  path: '/throw?:err',
  component: Throw,
}

export default [
  Home,
  BookingManager,
  Todos,

  MyProvings,
  Participants,
  AssignedWorker,
  ProvingsByMaintenanceHead,
  MyBookings,
  Archives,
  Provings,
  Synergies,
  Mailbox,
  ResourceBookings,
  Persons,
  Wiki,
  Admin,
  ThrowRoute,
  News,
  TaxRequirements,
] as Route[]
